<template>
    <div>
        <FormManager
                @save="save"
                @update="update"
                :events="events"
                prettyEndPoint='api/utilities/pretty_pattern_definition_map'
                :initialFormValues="patternDefinition"
        />
    </div>

</template>

<script>
    export default {
        name: "PatternEditorStandard",
        mounted() {
          this.changePattern()
        },
        data() {
            return {
                events: {
                    save: {
                        label: "Save for testing",
                        event: "save"
                    },
                }
            }
        },
        props: ['extentId','patternDefinition'],
        watch: {
          patternDefinition: {
            handler(newValue, oldValue) {
              this.changePattern()
            },
            deep: true
          }
        },
        methods: {
            changePattern() {
              console.log('pattern definition changed')
              if (this.patternDefinition && this.patternDefinition.id) {
                this.events.save.label = 'Update'
                this.events.save.event = 'update'
              } else {
                this.events.save.label = 'Save'
                this.events.save.event = 'save'
              }
              console.log(this.patternDefinition)
              if (!this.patternDefinition ||
                  (this.patternDefinition && this.patternDefinition.type_tag && this.patternDefinition.type_tag==='unsaved')) {
                  this.events.save.label = this.events.save.label + ' for testing'
              }
            },
            update(values) {
                console.log(values)
                axios.patch('/api/patterns/' + this.extentId, {
                  values: values
                }).then(response => {
                  console.log(response)
                  this.$emit('updatedPattern', values);
                  console.log('finished updating pattern')
                }).catch(error => {
                  console.log('Could now update pattern')
                  console.log(error.response)
                });
            },
            save(values) {
                console.log(values)
                axios.post('/api/patterns/' + this.extentId, {
                    values: values
                }).then(response => {
                    console.log(response)
                    values.id = response.data
                    this.$emit('newPattern', values);
                    console.log('finished saving new data source')
                }).catch(error => {
                    console.log('Could not save new data source')
                    console.log(error.response)
                });
            }
        }
    }
</script>

<style scoped>

</style>